const chestAnteriorMale = require('../assets/chest_male_anterior.png');
const chestAnteriorFemale = require('../assets/chest_female_anterior.png');

const maleHeartSounds = {
  picture: chestAnteriorMale,
  spots: [
    {
      x: '39.523809523809526%',
      y: '20.333333333333334%',
      position: 0,
      tooltipPlacement: 'right',
    },
    {
      x: '54.85714285714286%',
      y: '20.857142857142856%',
      position: 1,
      tooltipPlacement: 'left',
    },
    {
      x: '55.333333333333336%',
      y: '33.380952380952383%',
      position: 2,
      tooltipPlacement: 'left',
    },
    {
      x: '55.333333333333336%',
      y: '45.428571428571427%',
      position: 3,
      tooltipPlacement: 'left',
    },
    {
      x: '70.04761904761905%',
      y: '49.095238095238095%',
      position: 4,
      tooltipPlacement: 'left',
    },
  ],
};

const femaleHeartSounds = {
  ...maleHeartSounds,
  picture: chestAnteriorFemale,
};

export default {
  CUSTOM: maleHeartSounds,
  AMY: femaleHeartSounds,
  BEN: maleHeartSounds,
  HAWTHORN: maleHeartSounds,
  JOSHUA: maleHeartSounds,
  PATRICIA: femaleHeartSounds,
  SHERYL: femaleHeartSounds,
  MILITARY_AMY: femaleHeartSounds,
  MILITARY_BEN: maleHeartSounds,
  MILITARY_HAWTHORN: maleHeartSounds,
  MILITARY_JOSHUA: maleHeartSounds,
  MILITARY_PATRICIA: femaleHeartSounds,
  MILITARY_SHERYL: femaleHeartSounds,
  KIM: femaleHeartSounds,
  LIAM: maleHeartSounds,
  MILES: maleHeartSounds,
};

